export default "__VITE_ASSET__mQhaZGue__"